import LegalPage from "./LegalPage";

export default function Terms() {
  return <LegalPage testId="terms-page" path="/terms" page="terms" />;
}
